import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addAssignmentAsync, getAssignmentByIdAsync, getAssignmentDetailByIdAsync, updateAssignmentContractAsync, getFreelancerAssignmentByStatusAsync, updateAssignmentAsync, getFreelancerAssignmentsAsync, getFreelancerAssignmentByStatusWithReasonAsync, getFreelancerAssignmentByApprovedTimsheetAsync, updateAssignmentContractEndDateAsync, terminateAssignmentAsync, extendAssignmentAsync } from './assignmentThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const assignmentSlice = createSlice({
    name: 'assignment',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAssignmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(addAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateAssignmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFreelancerAssignmentByStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFreelancerAssignmentByStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Assignments = action.payload;
        })
            .addCase(getFreelancerAssignmentByStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFreelancerAssignmentByApprovedTimsheetAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFreelancerAssignmentByApprovedTimsheetAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.AssignmentsForInvoice = action.payload;
        })
            .addCase(getFreelancerAssignmentByApprovedTimsheetAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFreelancerAssignmentByStatusWithReasonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFreelancerAssignmentByStatusWithReasonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.AssignmentsWithReasons = action.payload;
        })
            .addCase(getFreelancerAssignmentByStatusWithReasonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAssignmentDetailByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAssignmentDetailByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.currentAssignment = action.payload;
        })
            .addCase(getAssignmentDetailByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFreelancerAssignmentsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFreelancerAssignmentsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Assignments = action.payload;
        })
            .addCase(getFreelancerAssignmentsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAssignmentByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAssignmentByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.AssignmentWithClient = action.payload;
        })
            .addCase(getAssignmentByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateAssignmentContractAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateAssignmentContractAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateAssignmentContractAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateAssignmentContractEndDateAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateAssignmentContractEndDateAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateAssignmentContractEndDateAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(extendAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(extendAssignmentAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(extendAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(terminateAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(terminateAssignmentAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(terminateAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default assignmentSlice.reducer;
